import type { ComponentProps, FC, SVGProps } from 'react';
import styled from '@emotion/styled';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { LoginBrandName } from 'src/types/Login';
import { pushEvent } from 'src/utils/event-gateway';

/**
 * TODO: react-apple-login 의 render props 타입 조건이 이상해서 불가피하게 추가함.
 * react-apple-login 을 제거하는 등의 리팩토링을 진행한 후 styled.button 으로 복귀할 것.
 */
const Container = styled('button' as 'div')`
  all: unset;
  cursor: pointer;

  border-width: 1px;
  border-style: solid;
  border-color: ${({
  theme
}) => theme.color.surface5};

  background-color: transparent;

  height: 52px;
  padding: 0 15px;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 700;
  color: ${({
  theme
}) => theme.color.content11};

  > svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  > span {
    flex: 1;

    text-align: center;
  }
`;
interface Props extends Pick<ComponentProps<'div'>, 'onClick' | 'className'> {
  brand: LoginBrandName;
  icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
}
const VividiLoginButton = ({
  brand,
  icon: Icon,
  label,
  onClick,
  ...props
}: Props) => <Container {...props} onClick={event => {
  event.preventDefault();
  onClick?.(event);
  pushEvent({
    eventType: EVENT_TYPE.SIGN_UP,
    eventName: EVENT_NAME.SCREEN_OPEN__LOGIN_METHOD,
    eventParams: {
      Method: brand.toLowerCase()
    }
  });
}} data-sentry-element="Container" data-sentry-component="VividiLoginButton" data-sentry-source-file="Button.tsx">
    <Icon data-sentry-element="Icon" data-sentry-source-file="Button.tsx" />
    <span>{label}</span>
  </Container>;
export default VividiLoginButton;